import { mergeSelectedIdMap } from "./mergeSelectedIdMap";
import {
  mergePositivePageNumber,
  mergeSingleColumnSortConfig,
} from "./stickyFilterMergeUtils";
import {
  clearStickyFilters,
  loadStickyFilters,
  saveStickyFilters,
} from "./stickyFilterStorage";

export const REQUEST_LIST_SCREEN_KEYS = {
  SPONSOR_LIBRARY_REQUESTS: "sponsorLibraryRequests",
  ADMIN_LIBRARY_REQUESTS: "adminLibraryRequests",
  SPONSOR_VQQS: "sponsorVqqs",
  ADMIN_VQQS: "adminVqqs",
  VENDOR_VQQS: "vendorVqqs",
  SPONSOR_ASSESSMENTS: "sponsorAssessments",
  ADMIN_ASSESSMENT_REQUESTS: "adminAssessmentRequests",
};

export const EMPTY_DUE_DATE_FILTER = Object.freeze({
  startDate: "",
  endDate: "",
});

function mergeDueDateFilter(saved) {
  if (!saved || typeof saved !== "object") {
    return { ...EMPTY_DUE_DATE_FILTER };
  }

  return {
    startDate: typeof saved.startDate === "string" ? saved.startDate : "",
    endDate: typeof saved.endDate === "string" ? saved.endDate : "",
  };
}

/**
 * Hydrates request-list (Library Requests / VQQ / VQA) sticky filter state.
 *
 * @param {string} screenKey
 * @param {{
 *   emptySelectedIds: Record<string, unknown[]>,
 *   defaultSortConfig: Record<string, { direction: string }>,
 *   includeDueDate?: boolean,
 * }} options
 */
export function loadRequestListFilterState(screenKey, options) {
  const {
    emptySelectedIds,
    defaultSortConfig,
    includeDueDate = false,
  } = options;
  const saved = loadStickyFilters(screenKey);

  const state = {
    selectedIds: mergeSelectedIdMap(saved?.selectedIds, emptySelectedIds),
    sortConfig: mergeSingleColumnSortConfig(
      saved?.sortConfig,
      defaultSortConfig
    ),
    currentPage: mergePositivePageNumber(saved?.currentPage),
  };

  if (includeDueDate) {
    state.dueDateFilter = mergeDueDateFilter(saved?.dueDateFilter);
  }

  return state;
}

/** Persists request-list sticky filter state for a screen. */
export function persistRequestListFilterState(screenKey, filterState) {
  if (!screenKey || !filterState) {
    return;
  }

  saveStickyFilters(screenKey, filterState);
}

/** Clears persisted request-list filters for a screen. */
export function clearRequestListFilterState(screenKey) {
  clearStickyFilters(screenKey);
}
